module.exports = __webpack_public_path__ + "static/img/index-sys1.acbe471.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-sys1.svg
// module id = 3lSg
// module chunks = 11